import { api } from '@/api/api';

import { segmentSchema } from './segmentSchema';
import { segmentTemplates } from './segmentTemplates';
import { segmentCampaign } from './segmentCampaign';
import { segmentExports } from './segmentExports';

export const segment = {
  namespaced: true,
  modules: {
    exports: segmentExports,
    schema: segmentSchema,
    templates: segmentTemplates,
    campaign: segmentCampaign,
  },
  state: {
    fetchingList: true,
    list: [],
    changingSegment: false,
    currentId: -1,
  },
  getters: {
    empty(state) {
      return state.list.length === 0;
    },
    currentSegment(state) {
      return state.list.find((segment) => segment.id === state.currentId) || {};
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setChanging(state, changing) {
      state.changingSegment = changing;
    },
    setSegments(state, segments) {
      state.list = segments;
    },
    setCurrentSegment(state, segmentId) {
      state.currentId = segmentId;
    },
    addSegment(state, segment) {
      state.list.push(segment);
    },
  },
  actions: {
    async fetchSegments({ rootState, commit, dispatch }) {
      if (rootState.company.currentId === -1) {
        return;
      }
      commit('setFetching', true);
      const { data } = await api.get(
        `companies/${rootState.company.currentId}/segments/`
      );
      commit(
        'setSegments',
        data.map((campaign) => ({
          ...campaign,
          editing: false,
        }))
      );
      commit('setFetching', false);
      if (data.length > 0) {
        let toSegment = data[0].id;
        const lastSegment = window.localStorage.getItem('lastSegment');
        if (lastSegment) {
          const exists = data.find(
            (segment) => segment.id === Number(lastSegment)
          );
          if (exists) {
            toSegment = Number(lastSegment);
          }
        }
        dispatch('changeSegment', toSegment);
      }
    },
    async updateSegment({ rootState, state, commit }, segment) {
      await api.patch(
        `companies/${rootState.company.currentId}/segments/${segment.id}/`,
        segment
      );
      commit(
        'setSegments',
        state.list.map((s) => {
          if (s.id === segment.id) {
            return segment;
          }
          return s;
        })
      );
    },
    async addSegment({ rootState, commit }, segment) {
      const { data } = await api.post(
        `companies/${rootState.company.currentId}/segments/`,
        segment
      );
      const newSegment = {
        ...data,
        editing: false,
      };
      commit('addSegment', newSegment);
    },
    async changeSegment({ commit, dispatch }, segmentId) {
      window.localStorage.setItem('lastSegment', segmentId);
      commit('setCurrentSegment', segmentId);
      commit('setChanging', true);
      await Promise.all([
        dispatch('schema/fetchSchemas'),
        dispatch('templates/fetchTemplates'),
        dispatch('campaign/fetchCampaigns'),
      ]);
      commit('setChanging', false);
    },
  },
};
